(function() {
    'use strict';

    angular.module('order')
        .controller('OrderCreateController', OrderCreateController);

    OrderCreateController.$inject = ['$state', '$scope', 'orderDataSrvc', 'orderSrvc', 'clientDataSrvc', 'productCountryConst', 'orderCurrencyOptionsConst', 'orderPlShopLangOptionsConst', 'orderDeShopLangOptionsConst', 'notificationSrvc', 'orderCreateMessagesConst', 'productDataSrvc', 'productOptionDataSrvc', 'formatDataSrvc', 'orderStatusConst', 'errorNotificationSrvc'];

    function OrderCreateController($state, $scope, orderDataSrvc, orderSrvc, clientDataSrvc, productCountryConst, orderCurrencyOptionsConst, orderPlShopLangOptionsConst, orderDeShopLangOptionsConst, notificationSrvc, orderCreateMessagesConst, productDataSrvc, productOptionDataSrvc, formatDataSrvc, orderStatusConst, errorNotificationSrvc) {
        var self = this;

        self.createLoading = false;

        self.serverErrors = {
            client: [],
            order_products: [],
            company_localization: [],
            lang: [],
            currency: [],
            realization_date: [],
            status: [],
            external_delivery_price: [],
            my_address_as_sender: [],
            is_invoice_paper: [],
            nonFieldErrors: []
        };

        self.orderData = {
            client: null,
            order_products: [],
            company_localization: undefined,
            lang: undefined,
            currency: undefined,
            realization_date: undefined,
            payment_method: undefined,
            status: undefined,
            external_delivery_price: undefined,
            my_address_as_sender: false,
            is_invoice_paper: false
        };

        self.countryList = productCountryConst;
        self.currencies = orderCurrencyOptionsConst;
        self.langs = orderPlShopLangOptionsConst.concat(orderDeShopLangOptionsConst);
        self.clients = [];
        self.products = [];
        self.productOptions = [];
        self.productData = {
            item: undefined
        };
        self.paymentMethods = [];
        self.formats = [];
        self.statuses = [
            orderStatusConst.in_production
        ];

        self.onClientSearch = onClientSearch;
        self.onProductSearch = onProductSearch;
        self.onProductOptionSearch = onProductOptionSearch;
        self.onProductChange = onProductChange;
        self.onCompanyLocalizationChange = onCompanyLocalizationChange;
        self.initOptions = initOptions;
        self.removeProduct = removeProduct;
        self.cloneProduct = cloneProduct;
        self.initProductFile = initProductFile;
        self.createOrder = createOrder;
        self.cleanErrors = cleanErrors;
        self.clearProductErrors = clearProductErrors;

        activate();

        function activate() {
            getClients();
            getProducts();
            getProductOptions();
            getPaymentMethods();
            getFormats();
        }

        function getClients() {
            return clientDataSrvc.getOptions().$promise.then(
                function(response) {
                    self.clients = response.results;
                    return response;
                }
            );
        }

        function getProducts() {
            return productDataSrvc.optionsList().$promise.then(
                function (response) {
                    self.products = response.results;
                    return response;
                }
            )
        }

        function getProductOptions() {
            return productOptionDataSrvc.optionsSearchList().$promise.then(
                function (response) {
                    self.productOptions = response.results;
                    return response;
                }
            )
        }

        function getPaymentMethods() {
            return orderDataSrvc.paymentMethods().$promise.then(
                function (response) {
                    self.paymentMethods = response.data;
                    return response;
                }
            )
        }

        function getFormats() {
            return formatDataSrvc.orderProductFormats().$promise.then(
                function (response) {
                    self.formats = response;
                    return response;
                }
            )
        }

        function onClientSearch(params) {
            if (!params) {
                params = {};
            }
            return clientDataSrvc.getOptions(
                params
            ).$promise;
        }

        function onProductSearch(params) {
            if (!params) {
                params = {};
            }
            return productDataSrvc.optionsList(
                params
            ).$promise;
        }

        function onProductOptionSearch(params) {
            if (!params) {
                params = {};
            }
            return productOptionDataSrvc.optionsSearchList(
                params
            ).$promise;
        }

        function onProductChange(product) {
            self.orderData.order_products.push(product);
            self.productData.item = undefined;
        }

        function onCompanyLocalizationChange() {
            self.cleanErrors('company_localization');
            self.orderData.lang = undefined;
            if (self.orderData.company_localization === 'PL') {
                self.langs = orderPlShopLangOptionsConst;
            } else if (self.orderData.company_localization === 'DE') {
                self.langs = orderDeShopLangOptionsConst;
            } else {
                self.langs = orderPlShopLangOptionsConst.concat(orderDeShopLangOptionsConst);
            }
        }

        function initOptions(product) {
            if (!product.hasOwnProperty('chosen_options')) {
                product.chosen_options = [];
            }
        }

        function removeProduct(index) {
            if (self.orderData.order_products[index]) {
                self.orderData.order_products.splice(index, 1);
            }
        }

        function cloneProduct(index) {
            if (self.orderData.order_products[index]) {
                self.orderData.order_products.push(angular.copy(self.orderData.order_products[index]));
            }
        }

        function initProductFile(product) {
            if (!product.hasOwnProperty('product_file')) {
                product.product_file = null;
            }
        }

        function createOrder() {
            self.createLoading = true;

            var order = angular.copy(self.orderData);
            angular.forEach(order.order_products, function (order_product) {
                order_product.product = order_product.pk;
                delete order_product.pk;

                order_product.chosen_options = order_product.chosen_options.map(function (chosen_option) {
                    var data = {
                        chosen_option: chosen_option.pk
                    };

                    if (chosen_option.hasOwnProperty('user_value')) {
                        data.user_value = chosen_option.user_value;
                    }

                    return data
                });
            });

            for (var i = 0; i < order.order_products.length; i++) {
                order.order_products[i].product_file = self.orderData.order_products[i].product_file
            }

            orderDataSrvc.create(order)
                .$promise
                .then(
                    function(response) {
                        notificationSrvc.notification("success", orderCreateMessagesConst.createSuccess);
                        self.createLoading = false;
                        $state.go('layout.order.list');
                    },
                    function(response) {
                        errorNotificationSrvc.displayErrors(response.data);
                        self.serverErrors = response.data;
                        self.createLoading = false;
                    }
                )

        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function clearProductErrors(index, key) {
            if (self.serverErrors.hasOwnProperty('order_products') && self.serverErrors.order_products[index]) {
                self.serverErrors.order_products[index][key] = [];
            }
        }
    }
})();
